import { ProductEditorBody } from "@pages/library/CreateProductEntityModal/ProductEditorBody";
import { useVideoRemakeStudio } from "./VideoRemakeStudioContext";

/**
 * 商品绑定后的内联编辑区域：图片缩略图 + Product Name + Category + Selling Points。
 *
 * - 当 productOrigin 为 link / library-saved → SellingPointsSection 不展示 Refresh 按钮（卖点来自链接 / Kalodata）
 * - 当 productOrigin 为 manual / library-created → 已经经过完整 ProductEditor 流程
 *   或 Created 已落库；这里允许编辑卖点但同样不需要 Refresh（PRD：refresh 仅手动模式）
 *
 * 设计稿节点：3440:25898（页面内联展开版）。
 */
export const ProductBoundDetails = () => {
  const {
    form,
    imageFiles,
    sellingPointsStatus,
    productOrigin,
    updateForm,
    handleFilesChange,
    uploadFile,
    updateCaption,
    setSellingPoints,
    addSellingPoint,
    removeSellingPoint,
    inferAiSellingPoints,
  } = useVideoRemakeStudio();

  if (productOrigin === null) return null;

  const showRefresh = productOrigin === "manual" || productOrigin === "library-created";

  return (
    <section className="w-full">
      <ProductEditorBody
        form={form}
        imageFiles={imageFiles}
        sellingPointsStatus={sellingPointsStatus}
        variant="inline"
        showRefreshSellingPoints={showRefresh}
        alwaysShowSellingPoints
        onChangeForm={updateForm}
        onFilesChange={handleFilesChange}
        uploadFile={uploadFile}
        onChangeCaption={updateCaption}
        onChangeSellingPoints={setSellingPoints}
        onAddSellingPoint={addSellingPoint}
        onRemoveSellingPoint={removeSellingPoint}
        onRefreshSellingPoints={showRefresh ? inferAiSellingPoints : undefined}
      />
    </section>
  );
};
